@if (display()) {
  <ts-badge variant="info" [text]="text()" [class]="class" />
}
